<div class="report-row no-break">
  <div class="top">
    <div class="left print-cell">
      <div class="title">
        <div class="top">{{ icfCategoryLabels[item.icfCategory] }}</div>
        <div class="bottom">{{ item.icfCategory }}</div>
      </div>
      <div class="score">
        <app-icf-box-large
          class="score-bar"
          [icfCategory]="item.icfCategory"
          [icfSelectedByUser]="item.icfScoreSelected ?? -1"
          [valuePercent]="item.scoreAverage ?? 0"></app-icf-box-large>
      </div>
    </div>
    <div class="custom-note print-cell">
      <p>
        @if (item.customNote) {
          {{ item.customNote }}
        } @else {
          <i class="no-note no-print">Kommentar hinzufügen</i>
        }
        <span class="edit-container no-print">
          <button class="edit-button" (click)="editCustomNote(item)" mat-icon-button>
            <mat-icon>edit</mat-icon>
          </button>
        </span>
      </p>
    </div>
    <div class="right print-cell">
      @for (detail of item.details | reportItemDetailsAggregation; track $index) {
        <div class="subtest-row">
          <div class="subtest-name" data-tst="subtest-details">
            @if (detail.type === 'ARAT') {
              <span class="top"> {{ detail.type }}</span>
              @if (detail.aggregatedSubTypeCount === 1) {
                <span class="bottom"> {{ detail.aggregatedSubTypeCount }} Subtest</span>
              } @else {
                <span class="bottom"> {{ detail.aggregatedSubTypeCount }} Subtests</span>
              }
            } @else {
              <span> {{ detail.type }}</span>
            }
          </div>
          <div class="subtest-score">
            <app-icf-bar-percent [id]="detail.type" [value]="detail.scorePercentAverage ?? 100"></app-icf-bar-percent>
          </div>
        </div>
      }

      <!-- Reminder: Werte sind Schädigung, nicht Erfüllung!  -->
      <!-- @for (detail of item.details; track $index) {
        <div class="subtest-row">
          <div class="subtest-name">
            <span> {{ detail.type }}</span>
            @if (detail.type.toLowerCase() !== detail.subType) {
              @switch (detail.subType) {
                @case ('grip') {
                  <span> : Griff </span>
                }
                @case ('grasp') {
                  <span> : Greifen </span>
                }
                @case ('pinch') {
                  <span> : Präz. </span>
                }
                @case ('gross') {
                  <span> : Arm </span>
                }
              }
            }
          </div>
          <div class="subtest-score">
            <app-icf-bar-percent
              [id]="detail.type + detail.subType"
              [value]="detail.scorePercent ?? 100"></app-icf-bar-percent>
          </div>
        </div>
      } -->
    </div>
  </div>
  @if (isCategoryDesciptionEnabled) {
    <div class="icf-description no-break">
      <p>Beschreibung der Kategorie:</p>
      <p>{{ icfCategoryDescription[item.icfCategory].label }}</p>
      @if (icfCategoryDescription[item.icfCategory].inclusion !== '') {
        <p>Inkl.: {{ icfCategoryDescription[item.icfCategory].inclusion }}</p>
      }
      @if (icfCategoryDescription[item.icfCategory].exclusion !== '') {
        <p>Exkl.: {{ icfCategoryDescription[item.icfCategory].exclusion }}</p>
      }
    </div>
  }
</div>
